
import { useEffect } from "react";

import "./Program.css";
import "../Home/Components/attributes/Attributes.css"

import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";

const ToddlerProgram = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, []);

    return (<>

        <Navbar />

        <div className="about-main">

            <div className="about-sec-1">

                <div className="about-s2-1">
                    <h1>The Toddler Montessori Program <br/> <span>(Ages 1.5 – 3 years)</span></h1>
                    <div>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>The programme focuses on</span> supporting the earliest stage of human development, when the child is forming the foundation of their personality, independence, and understanding of the world.</p>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>Children in the Toddler program</span> at Anubhava are nurtured and supported as they make the transition from their home life to a daily school routine. The consistent and simple daily schedule provides comfort and security as your child quickly learns the order of his day, and is included in the care and keeping of the community.</p>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>The Toddler program is</span> a five day program. The children enjoy a two hour work period, a snack served family style, outdoor play, and is supported in their toilet awareness. Sometime between the ages of 1.5 to 3 years of age, your child’s language skills and self-expression will develop rapidly; he will express a growing confidence in independence and a keen interest in broader concepts.</p>
                    </div>
                    <button className="start-btn" style={{ marginTop: "80px" }} onClick={() => window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank")} >Enroll Now <i className="fa-solid fa-arrow-up"></i></button>
                </div>
                <div className="about-s2-2">
                    <div className="pi-toddler">

                    </div>
                </div>

            </div>

        </div>

        <Footer />

    </>)

}

export default ToddlerProgram;